import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Categories() {
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [search, setSearch] = useState("");

    useEffect(() => {
        loadCategories();
    }, [page, search]);

    const loadCategories = async () => {
        try {
            const token =
                localStorage.getItem("adminToken");

            const res = await API.get(
                `/categories?page=${page}&search=${search}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setCategories(
                res.data.categories || []
            );

            setPages(
                res.data.pages || 1
            );

        } catch (err) {
            console.log(err);
        }
    };

    const deleteCategory = async (id) => {

        if (!window.confirm("Delete Category?"))
            return;

        try {

            const token =
                localStorage.getItem("adminToken");

            await API.delete(
                `/categories/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            loadCategories();

        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="w-full">

            {/* HEADER */}

            <div
                className="
        flex
        flex-col
        md:flex-row
        md:items-center
        md:justify-between
        gap-4
        mb-6
      "
            >
                <h1
                    className="
          text-3xl
          md:text-4xl
          font-bold
        "
                >
                    Categories
                </h1>

                {hasPermission("category.add") && (
                    <Link
                        to="/admin/categories/add"
                        className="
                            w-full
                            md:w-auto
                            text-center
                            px-5
                            py-3
                            bg-yellow-500
                            text-black
                            rounded-xl
                            font-semibold
                            "
                    >
                        Add Category
                    </Link>
                )}


            </div>

            {/* SEARCH */}

            <input
                value={search}
                onChange={(e) =>
                    setSearch(e.target.value)
                }
                placeholder="Search Category..."
                className="
        w-full
        md:w-96
        p-3
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        mb-6
        outline-none
      "
            />

            {/* MOBILE VIEW */}

            <div className="md:hidden space-y-4">

                {categories.map((item) => (

                    <div
                        key={item.id}
                        className="
            bg-[#111]
            border
            border-yellow-500/10
            rounded-2xl
            p-4
          "
                    >
                        <div className="flex justify-between">
                            <span>ID</span>
                            <span>{item.id}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Name</span>
                            <span>{item.name}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Status</span>

                            <span
                                className={
                                    item.status === "active"
                                        ? "text-green-500"
                                        : "text-red-500"
                                }
                            >
                                {item.status}
                            </span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Date</span>

                            <span>
                                {new Date(
                                    item.created_at
                                ).toLocaleDateString()}
                            </span>
                        </div>

                        <div className="flex gap-2 mt-4">

                            <button
                                onClick={() =>
                                    navigate(
                                        `/admin/categories/edit/${item.id}`
                                    )
                                }
                                className="
                flex-1
                py-2
                rounded-lg
                bg-blue-500
              "
                            >
                                Edit
                            </button>

                            <button
                                onClick={() =>
                                    deleteCategory(item.id)
                                }
                                className="
                flex-1
                py-2
                rounded-lg
                bg-red-500
              "
                            >
                                Delete
                            </button>

                        </div>

                    </div>

                ))}

            </div>

            {/* DESKTOP TABLE */}

            <div
                className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
      "
            >
                <div className="overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
              "
                            >
                                <th className="p-4 text-left">
                                    ID
                                </th>

                                <th className="p-4 text-left">
                                    Name
                                </th>

                                <th className="p-4 text-center">
                                    Status
                                </th>

                                <th className="p-4 text-center">
                                    Date
                                </th>

                                <th className="p-4 text-center">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {categories.map((item) => (

                                <tr
                                    key={item.id}
                                    className="
                  border-b
                  border-yellow-500/10
                "
                                >
                                    <td className="p-4">
                                        {item.id}
                                    </td>

                                    <td className="p-4">
                                        {item.name}
                                    </td>

                                    <td className="p-4 text-center">

                                        <span
                                            className={
                                                item.status === "active"
                                                    ? "text-green-500"
                                                    : "text-red-500"
                                            }
                                        >
                                            {item.status === "active"
                                                ? "Active"
                                                : "Inactive"}
                                        </span>

                                    </td>

                                    <td className="p-4 text-center">
                                        {new Date(
                                            item.created_at
                                        ).toLocaleDateString()}
                                    </td>

                                    <td className="p-4">

                                        <div
                                            className="
                      flex
                      justify-center
                      gap-2
                    "
                                        >

                                            {hasPermission("category.edit") && (
                                                <button
                                                    onClick={() =>
                                                        navigate(
                                                            `/admin/categories/edit/${item.id}`
                                                        )
                                                    }
                                                    className="
                                                        px-4
                                                        py-2
                                                        bg-blue-500
                                                        rounded-lg
                                                    "
                                                >
                                                    Edit
                                                </button>
                                            )}




                                            {hasPermission("category.delete") && (
                                                <button
                                                    onClick={() =>
                                                        deleteCategory(item.id)
                                                    }
                                                    className="
                                                        px-4
                                                        py-2
                                                        bg-red-500
                                                        rounded-lg
                                                    "
                                                >
                                                    Delete
                                                </button>
                                            )}


                                        </div>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>
            </div>

            {/* PAGINATION */}

            <div className="flex gap-2 mt-6 flex-wrap">

                <button
                    disabled={page === 1}
                    onClick={() =>
                        setPage(page - 1)
                    }
                    className="
          px-4
          py-2
          rounded-lg
          bg-[#111]
        "
                >
                    Back
                </button>

                {Array.from({ length: pages }, (_, i) => i + 1)
                    .filter(
                        p =>
                            p === 1 ||
                            p === pages ||
                            (p >= page - 1 &&
                                p <= page + 1)
                    )
                    .map((p, index, arr) => (
                        <div key={p} className="flex">
                            {index > 0 &&
                                arr[index - 1] !== p - 1 && (
                                    <span className="px-2 flex items-center">
                                        ...
                                    </span>
                                )}

                            <button
                                onClick={() => setPage(p)}
                                className={`px-4 py-2 rounded-lg ${page === p
                                    ? "bg-yellow-500 text-black"
                                    : "bg-[#111]"
                                    }`}
                            >
                                {p}
                            </button>
                        </div>
                    ))}

                <button
                    disabled={page === pages}
                    onClick={() =>
                        setPage(page + 1)
                    }
                    className="
          px-4
          py-2
          rounded-lg
          bg-[#111]
        "
                >
                    Next
                </button>

            </div>

        </div>
    );
}

export default Categories;